import { useState } from 'react';

export default function QuickContact() {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    localizacao: '',
    tipoVeiculo: '',
    descricao: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6m4qtqqoe30lj0v87h0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          telefone: '',
          localizacao: '',
          tipoVeiculo: '',
          descricao: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contato" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          {/* Contact Info */}
          <div className="space-y-5 md:space-y-8">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-black mb-3 md:mb-6">Atendimento Imediato</h3>
              <p className="text-sm md:text-lg text-gray-600 mb-5 md:mb-8">
                Nossa equipe está pronta para atendê-lo 24 horas por dia, 7 dias por semana.
                Entre em contato pelos canais abaixo:
              </p>
            </div>
            <div className="space-y-3 md:space-y-6">
              <a href="https://wa.me/5514981800454" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-3 md:gap-4 p-4 md:p-6 bg-gray-50 rounded-2xl hover:bg-gray-100 transition-colors group cursor-pointer">
                <div className="w-11 h-11 md:w-14 md:h-14 bg-green-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shrink-0">
                  <i className="ri-whatsapp-fill text-white text-xl md:text-2xl"></i>
                </div>
                <div>
                  <p className="text-xs md:text-sm text-gray-600 font-medium">WhatsApp</p>
                  <p className="text-lg md:text-2xl font-bold text-black">(14) 98180-0454</p>
                </div>
              </a>
              <a href="mailto:contato@guinchoexpress.com.br"
                className="flex items-center gap-3 md:gap-4 p-4 md:p-6 bg-gray-50 rounded-2xl hover:bg-gray-100 transition-colors group cursor-pointer">
                <div className="w-11 h-11 md:w-14 md:h-14 bg-gray-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shrink-0">
                  <i className="ri-mail-fill text-white text-xl md:text-2xl"></i>
                </div>
                <div>
                  <p className="text-xs md:text-sm text-gray-600 font-medium">E-mail</p>
                  <p className="text-sm md:text-xl font-bold text-black break-all">contato@guinchoexpress.com.br</p>
                </div>
              </a>
            </div>
            <div className="bg-yellow-50 border-2 border-yellow-500 rounded-2xl p-4 md:p-6">
              <div className="flex items-start gap-3 md:gap-4">
                <i className="ri-information-fill text-2xl md:text-3xl text-yellow-600 mt-0.5 shrink-0"></i>
                <div>
                  <h4 className="font-bold text-black text-base md:text-lg mb-1 md:mb-2">Atendimento 24 Horas</h4>
                  <p className="text-gray-700 text-sm md:text-base">
                    Estamos disponíveis todos os dias, incluindo finais de semana e feriados.
                    Seu guincho chegará em até 10 minutos!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}